// todo - review class position + name - added in kind of rush

import * as api from '../api';
import { ITEM_TYPE, PATH } from '../constants';

export const getItemLook = (itemData) => {
  const itemLook = {
    ico: '',
    imgUrl: '',
  };
  switch (itemData.type) {
    case ITEM_TYPE.VIDEO:
    case ITEM_TYPE.MEMORY:
    case ITEM_TYPE.VYSILANI:
      itemLook.ico = 'play';
      itemLook.imgUrl = api.videoImageUrl(itemData);
      break;
    case ITEM_TYPE.ARTICLE:
      itemLook.ico = 'read';
      itemLook.imgUrl = `${PATH.IMG}articles/${itemData.image_id}.jpg`;
      break;
    case ITEM_TYPE.INFOGRAPHIC:
      itemLook.ico = 'stats';
      itemLook.imgUrl = `${PATH.DATA}infographic/thumbs/${itemData.image_id}.jpg`;
      break;
    case ITEM_TYPE.MAP:
      itemLook.ico = 'map';
      itemLook.imgUrl = `${PATH.DATA}maps/thumbs/${itemData.image_id}.jpg`;
      break;
    case ITEM_TYPE.CATEGORY:
      itemLook.imgUrl = `${PATH.IMG}homepage/${itemData.categoryId}.jpg`;
      break;
    case ITEM_TYPE.SPECIAL:
      itemLook.imgUrl = `${PATH.IMG}homepage/${itemData.id}.jpg`;
      break;
    case ITEM_TYPE.SCHOOL_SHEET:
      itemLook.imgUrl = `${PATH.SCHOOL}img/${itemData.id}/cover.jpg`;
      break;
    default:
  }
  return itemLook;
};




// WEBPACK FOOTER //
// ./src/utils/ItemsHelper.js